import React from 'react'
import { cn } from '@/utils/ui'
import { Label } from '@/ui/atoms/Label'
import RichText from '@/ui/components/RichText'

export type TableInfoRowProps = {
  label?: string
  value?: string
  valueRichText?: any
  useRichText?: boolean
  className?: string
  valueClassName?: string
}

export const TableInfoRow: React.FC<TableInfoRowProps> = ({
  label,
  value,
  valueRichText,
  useRichText,
  className,
  valueClassName,
}) => {
  return (
    <div className={cn('py-4 grid grid-cols-1 lg:grid-cols-[3fr_7fr] gap-2', className)}>
      <div className={`lg:ps-card-s ps-mobile-card-s`}>
        <Label variant="plain" className="text-body-S-semibold text-text-base px-0" title={label} />
      </div>
      <div className={cn('relative flex lg:pe-card-s pe-0 lg:ps-0 ps-mobile-card-s')}>
        {useRichText && valueRichText ? (
          <RichText
            data={valueRichText}
            className={cn(
              '!text-body-S-regular text-text-base',
              '[&_ul]:list-disc [&_ul]:pl-6 [&_ul]:mb-2',
              '[&_ul>li]:text-text-base [&_ul>li]:mb-1 [&_ul>li]:marker:text-text-base',
              '[&_ol]:list-decimal [&_ol]:pl-6 [&_ol]:mb-2',
              '[&_ol>li]:text-text-base [&_ol>li]:mb-1 [&_ol>li]:marker:text-text-base',
              '[&_p]:mb-2 [&_p:last-child]:mb-0',
              '[&_a]:underline [&_a]:text-blue-600 hover:[&_a]:text-blue-800',
              valueClassName
            )}
            enableGutter={false}
            enableProse={false}
            variant="plain"
          />
        ) : (
          <div className={cn('!text-body-S-regular text-text-base', valueClassName)}>{value}</div>
        )}
      </div>
    </div>
  )
}
